module.exports = __webpack_public_path__ + "static/img/星图-设备类型.26694e52.png";